import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/bulk-import')({ component: Outlet });
